import { render } from "./CustomInput.vue?vue&type=template&id=dc60c13a&scoped=true&ts=true"
import script from "./CustomInput.vue?vue&type=script&lang=ts"
export * from "./CustomInput.vue?vue&type=script&lang=ts"

import "./CustomInput.scss?vue&type=style&index=0&id=dc60c13a&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc60c13a"]])

export default __exports__